import styled from "styled-components";

export const RouteMapFilterContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ columns }) => columns || "230px 150px 57px 90px"};
  grid-column-gap: ${({ gap }) => gap || "30px"};
  align-items: center;
  margin: 0;
/* Slightly smaller screens: reduce gap */
  @media screen and (max-width: 1400px) {
    grid-column-gap: 18px;
  }

  /* Tablet: 2-column, 2-row layout */
  @media screen and (max-width: 1024px) and (min-width: 901px) {
    grid-template-columns: 90% 10%;
    grid-template-rows: auto auto;
    grid-template-areas: 
      "row1 row1"
      "row2a row2b";
    grid-row-gap: 12px;

    & > :nth-child(1) { grid-area: row1; }
    & > :nth-child(2) { grid-area: row2a; }
    & > :nth-child(3) { grid-area: row2b; }
  }

  /* Mobile: single column */
  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-row-gap: 12px;

    /* Optional: reset areas */
    & > :nth-child(1),
    & > :nth-child(2),
    & > :nth-child(3) {
      grid-area: auto;
    }
  }
`;